import { paymentMethodCreationError } from 'lib/common/messages';
import addMessage from 'action-creators/messaging/add-message';

export default function createPaymentMethodError() {
  return addMessage(paymentMethodCreationError);
}
